interface Lead {
  status: string;
}

interface ConversionFunnelProps {
  leads: Lead[];
}

const STAGES = [
  { key: 'new', label: 'Yeni Lead', icon: 'ri-user-add-line', color: '#f0b429' },
  { key: 'contacted', label: 'İletişime Geçildi', icon: 'ri-phone-line', color: '#38bdf8' },
  { key: 'qualified', label: 'Nitelikli', icon: 'ri-shield-check-line', color: '#a78bfa' },
  { key: 'converted', label: 'Dönüştürüldü', icon: 'ri-trophy-line', color: '#34d399' },
];

export default function ConversionFunnel({ leads }: ConversionFunnelProps) {
  const total = leads.length || 1;

  const stageCounts = STAGES.map((s) => ({
    ...s,
    count: leads.filter((l) => l.status === s.key).length,
  }));

  const lost = leads.filter((l) => l.status === 'lost').length;
  const conversionRate = total > 1
    ? ((stageCounts[3].count / (total - 1)) * 100).toFixed(1)
    : '0.0';

  return (
    <div
      className="rounded-2xl p-5"
      style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}
    >
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="text-white font-bold text-sm">Dönüşüm Hunisi</h3>
          <p className="text-gray-300 text-xs mt-0.5">Her aşamadaki lead sayısı ve oranı</p>
        </div>
        <div
          className="px-3 py-1.5 rounded-xl text-xs font-black"
          style={{ background: 'rgba(52,211,153,0.12)', color: '#34d399', border: '1px solid rgba(52,211,153,0.2)' }}
        >
          %{conversionRate} dönüşüm
        </div>
      </div>

      <div className="space-y-3">
        {stageCounts.map((stage, i) => {
          const pct = leads.length > 0 ? (stage.count / leads.length) * 100 : 0;
          const width = 100 - i * 12;
          return (
            <div key={stage.key} className="relative">
              <div
                className="rounded-xl px-4 py-3 flex items-center gap-3"
                style={{
                  background: `${stage.color}10`,
                  border: `1px solid ${stage.color}20`,
                  marginLeft: `${i * 4}%`,
                  width: `${width}%`,
                  transition: 'all 0.5s ease',
                }}
              >
                <div
                  className="w-8 h-8 flex items-center justify-center rounded-xl flex-shrink-0"
                  style={{ background: `${stage.color}20` }}
                >
                  <i className={`${stage.icon} text-sm`} style={{ color: stage.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <span className="text-white text-xs font-semibold">{stage.label}</span>
                    <div className="flex items-center gap-2">
                      <span className="text-gray-300 text-xs">%{pct.toFixed(0)}</span>
                      <span className="text-white font-black text-sm">{stage.count}</span>
                    </div>
                  </div>
                  <div className="mt-1.5 h-1 rounded-full" style={{ background: 'rgba(255,255,255,0.08)' }}>
                    <div
                      className="h-1 rounded-full transition-all duration-700"
                      style={{ width: `${pct}%`, background: stage.color }}
                    />
                  </div>
                </div>
              </div>
              {i < stageCounts.length - 1 && (
                <div
                  className="flex items-center justify-center py-0.5"
                  style={{ marginLeft: `${(i + 0.5) * 4 + 2}%` }}
                >
                  <i className="ri-arrow-down-s-line text-gray-700 text-xs" />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {lost > 0 && (
        <div
          className="mt-3 flex items-center gap-2 px-4 py-2.5 rounded-xl"
          style={{ background: 'rgba(248,113,113,0.08)', border: '1px solid rgba(248,113,113,0.15)' }}
        >
          <i className="ri-close-circle-line text-xs" style={{ color: '#f87171' }} />
          <span className="text-gray-200 text-xs">Kaybedilen lead:</span>
          <span className="text-white font-bold text-xs">{lost}</span>
          <span className="text-gray-300 text-xs ml-auto">%{leads.length > 0 ? ((lost / leads.length) * 100).toFixed(0) : 0}</span>
        </div>
      )}
    </div>
  );
}
